import {gettext} from 'topmeteo/utils/i18n';

const HelpText = gettext('Define start and destination for current messages.');

const Toggle = ({label, onClick}) => (
    <div className="metar-taf-map-toggler">
        <p>{HelpText}</p>
        <span className="toggle-icon" title={label} onClick={onClick} />
        <div className="ctl-metar-taf-map-toggle">
            <button className="met-btn" title={label} onClick={onClick}>{label}</button>
        </div>
    </div>
);

export default Toggle;
